var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@mui/material";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import { Logo } from "../../../../../Atoms";
import { COLORS } from "../../../../../../constants";
var BrokerLogo = function (_a) {
    var logo = _a.logo, diameter = _a.diameter;
    return logo ? (_jsx(Logo, { "data-testid": "broker-logo", logoUrl: logo, diameter: diameter, blankSpace: 4, hideBorder: true })) : (_jsx(Box, __assign({ sx: {
            width: "".concat(diameter, "px"),
            height: "".concat(diameter, "px"),
            background: COLORS.WHITE,
            border: "1px solid ".concat(COLORS.P_OUTLINE),
            borderRadius: "100px",
            position: "relative",
        } }, { children: _jsx(Box, __assign({ sx: {
                position: "absolute",
                background: COLORS.P_OUTLINE,
                left: "2.63%",
                right: "2.63%",
                top: "2.63%",
                bottom: "2.63%",
                borderRadius: "100px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
            } }, { children: _jsx(AccountBalanceIcon, { sx: { width: "50%", height: "50%" } }) })) })));
};
export default BrokerLogo;
